import { AppUserModel } from "../model/AppUserModel";
import { ApiClient } from "../api/ApiClient";

class AuthServiceClass {
  login(username: string, password: string) {
    return ApiClient.post<AppUserModel>("/api/login", {
      username: username,
      password: btoa(password),
    });
  }

  register(username: string, password: string, full_name: string) {
    return ApiClient.post("/api/register", {
      username: username,
      password: btoa(password),
      full_name: full_name,
    });
  }

  administratorRegister(username: string, password: string, full_name: string) {
    return ApiClient.post("/api/admin/register", {
      username: username,
      password: btoa(password),
      full_name: full_name,
    });
  }
}
export const AuthService = new AuthServiceClass();
